import { gsap } from "@/vendor/gsap";
import { ScrollTrigger } from "@/vendor/gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function animateFrom(elem, direction) {
    direction = direction || 1;

    let x = 0;
    let y = direction * 100;

    elem.style.transform = "translate(" + x + "px, " + y + "px)";
    elem.style.opacity = "0";

    gsap.fromTo(
        elem,
        { x: x, y: y, autoAlpha: 0 },
        {
            duration: 0.75,
            x: 0,
            y: 0,
            autoAlpha: 1,
            ease: "expo",
            overwrite: "auto",
        }
    );
}

function hide(elem) {
    gsap.set(elem, { autoAlpha: 0 });
}

export const init = () => {
    const textElements = gsap.utils.toArray(`
        main .text > *
    `);

    textElements.forEach((elem) => {
        const section = elem.closest(".section");
        hide(elem); // assure that the element is hidden when scrolled into view

        elem.style.opacity = 0;
        elem.style.visibility = "hidden";
        elem.style.willChange = "transform, opacity";

        ScrollTrigger.create({
            trigger: section,
            invalidateOnRefresh: true,
            // markers: true,
            start: "top bottom",
            onEnter: function () {
                animateFrom(elem);
            }
        });
    });

    // const resizeObserver = new ResizeObserver((entries) => {
    //     ScrollTrigger.refresh();
    // });

    // resizeObserver.observe(document.body);
};

export default init;
